export default __webpack_public_path__ + "static/media/132043945_1081021239048592_686347694524149166_n.c7165125.jpg";